import {
  IApiResponse,
  IChatParticipant,
  IChatPost,
  IChatResponse,
  ICreateChatResponse,
  IUserSession
} from 'types'
import {
  CHAT_CREATE_PARTICIPANT,
  CHAT_LAST_MESSAGE,
  CHAT_LIST,
  CHAT_MESSAGE,
  CHAT_PARTICIPANT
} from './CONSTANTS'
import { request } from 'services/base'
import { IPatientResponse } from 'types/patient/types'

export const getChatList = async (
  professionalId?: string
): Promise<IApiResponse<{ [key: string]: IChatParticipant[] }>> =>
  await request({ url: CHAT_LIST(professionalId), method: 'get' })

export const getChatParticipant = async (
  chatId?: string
): Promise<IApiResponse<Array<IPatientResponse | IUserSession>>> =>
  await request({ url: CHAT_PARTICIPANT(chatId), method: 'get' })

export const getChatMessage = async (
  chatId?: string,
  params?: {
    offset: number
    limit: number
  }
): Promise<IApiResponse<Array<IChatResponse>>> =>
  await request({ url: CHAT_MESSAGE(chatId), method: 'get', params })

export const getLastMessage = async (
  chatId?: string,
  params?: {
    after_datetime: string
  }
): Promise<IApiResponse<Array<any>>> =>
  await request({ url: CHAT_LAST_MESSAGE(chatId), method: 'get', params })

export const postChatMessage = async (
  chatId?: string,
  data?: IChatPost
): Promise<IApiResponse<Array<any>>> =>
  await request({ url: CHAT_MESSAGE(chatId), method: 'post', data })

export const postChat = async (
  participantId?: string
): Promise<IApiResponse<ICreateChatResponse>> =>
  await request({ url: CHAT_CREATE_PARTICIPANT(participantId), method: 'post' })
